export default "__VITE_ASSET__zx1$b9iY__"